import React, { Component } from 'react'
import CourseTable from './ClassTable';
import CourseAdd from './ClassAdd';
import { LinearProgress } from '@material-ui/core';
import Snack from '../../Snackbar/Snack';
import { PostData, GetData, PutData, DeleteData } from '../../../api/service';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css



export default class Class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            isLoading: true,
            status: false,
            message: '',
            table_data: [],
            edit: false,
            edit_data: [],
            departments: [],
            isDeptLoaded: false,
            initialData: {
                courses: [],
                departments: [],
                streams: [],
                isInLoaded: false
            }
        }

    }

    __getData() {
        GetData('/getclass')
            .then((resp) => {
                if (resp.length > 0) {
                    this.setState({
                        table_data: resp,
                        isLoading: false
                    })
                } else {
                    this.setState({
                        table_data: [],
                        isLoading: false
                    })
                }
            })
    }

    componentDidMount() {
        this.__getData();

        let initialData = this.state.initialData;

        GetData('/getcourse')
            .then((resp) => {
                if (resp.length > 0) {
                    initialData['courses'] = resp
                }
            })
            .then(() => {
                GetData('/getstream')
                    .then((resp) => {
                        if (resp.length > 0) {
                            initialData['streams'] = resp
                        }
                    }).then(() => {
                        GetData('/getdepartment')
                            .then((resp) => {
                                if (resp.length > 0) {
                                    initialData['departments'] = resp
                                }
                            })
                            .then(() => {
                                //console.log(initialData)
                                this.setState({
                                    isInLoaded: true,
                                    initialData
                                })
                            })
                    })
            })
    }


    onAddClick() {
        this.setState({
            show: !this.state.show,
            edit: false
        })
    }

    setData(data) {
        //send the data to the server

        PostData(`/${this.props.apikey}/addclass`, data)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    show: false,
                    status: true,
                    message: resp,
                    edit: false
                })
                this.__getData();
            })
    }

    actionClick(el) {
        this.setState({
            edit: true,
            edit_data: el,
            show: true
        })
    }

    esetData(data) {
        //send the data to the server
        //console.log(data)

        PutData(`/${this.props.apikey}/${data.id}/updateclass`, data)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    show: false,
                    status: true,
                    message: resp
                })
                this.__getData();
            })
    }

    onDeleteClick(id) {
        //console.log(id)
        this.setState({
            show: false
        })
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: this.onDeleteConfirm.bind(this, id)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    onDeleteConfirm(id) {

        //console.log(id);
        DeleteData(`/${this.props.apikey}/${id}/deleteclass`)
            .then((resp) => {
                this.setState({
                    show: false,
                    status: true,
                    message: resp
                })
                this.__getData();
            })
    }


    render() {
        return (
            <div>
                {this.state.status ? <Snack 
                open={this.state.status} 
                message={this.state.message}
                handleClose={() => 
                    this.setState({
                        status: false,
                        message: ''
                    })
                }
                
                /> : null}
                {this.state.isLoading ? <LinearProgress color="secondary" /> : null}


                <CourseAdd
                    show={this.state.show}
                    handleClose={this.onAddClick.bind(this)}
                    setData={this.setData.bind(this)}
                    edit={this.state.edit}
                    edit_data={this.state.edit_data}
                    esetData={this.esetData.bind(this)}
                    onDeleteClick={this.onDeleteClick.bind(this)}
                    departments={this.state.departments}
                    isDeptLoaded={this.state.isDeptLoaded}
                    isInLoaded={this.state.isInLoaded}
                    initialData={this.state.initialData}
                />



                {!this.state.isLoading ? <CourseTable
                    table_data={this.state.table_data}
                    isLoading={this.state.isLoading}
                    onAddClick={this.onAddClick.bind(this)}
                    actionClick={this.actionClick.bind(this)} /> : null}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Master/Class/Class.js